import { ExternalTransportFormValues } from "../types/externalTransportTable.types";

export const DEFAULT_FORM_VALUES: ExternalTransportFormValues = {
  id: "",
  name: "",
  transportType: "",
  from: "",
  to: "",
  weight: "",
  weightUnit: "kg",
  distance: ""
};
